// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1l4Vr","col":"Table_col__vuVr0","fulfillmentStatus":"Table_fulfillmentStatus__ORVkW","emailCol":"Table_emailCol__10Scd"};